export const ROLES = {
  ADMIN: 1,
  USER: 2,
  EMPLOYEE: 3,
  CLERK: 4
};
